import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class BusyService  {
    busyObserver = new BehaviorSubject<boolean>(false);

    /**
     * Emmits busy-event
     */
    public markBusy() {
        this.busyObserver.next(true);
    }

    /**
     * Emmits not-busy-event
     */
    public markNotBusy() {
        this.busyObserver.next(false);
    }

}